/** Remove HTML tags from a string for safe plain-text display (handles unclosed tags). */
export function stripHtmlTags(str) {
    if (str == null || str === '') return '';
    let out = String(str).replace(/<[^>]*>/g, '');
    const unclosed = out.indexOf('<');
    if (unclosed !== -1) out = out.slice(0, unclosed);
    return out.replace(/\s+/g, ' ').trim();
}
 